import React from 'react';

const DeleteAdminConfirmation = ({ adminName, onConfirm, onCancel }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'white',
        borderRadius: '8px',
        padding: '2rem',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ marginTop: 0, marginBottom: '1rem', color: '#dc3545' }}>
          Delete Administrator Confirmation
        </h2>
        
        <p style={{ marginBottom: '1rem', fontSize: '1rem' }}>
          You are about to permanently delete administrator: <strong>"{adminName}"</strong>
        </p>

        <div style={{ 
          background: '#fee', 
          border: '1px solid #fcc', 
          borderRadius: '4px',
          padding: '1rem',
          marginBottom: '1.5rem'
        }}>
          <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.9rem', color: '#721c24' }}>
            <strong>Warning:</strong> This will permanently remove this administrator's access to the subscription. This action cannot be undone.
          </p>
          <p style={{ margin: 0, fontSize: '0.9rem', color: '#721c24' }}>
            This will not remove their User account if they have one, only their Admin account.
          </p>
        </div>

        <div style={{ 
          display: 'flex', 
          gap: '0.5rem', 
          justifyContent: 'flex-end'
        }}>
          <button
            className="btn btn-secondary"
            onClick={onCancel}
            style={{ padding: '0.75rem 1.5rem' }}
          >
            Cancel
          </button>
          
          <button
            className="btn btn-danger"
            onClick={onConfirm}
            style={{ padding: '0.75rem 1.5rem' }}
          >
            Delete Administrator
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAdminConfirmation;
